import React from "react";
import PropTypes from "prop-types";
import { icon_close_alert, icon_init_alert } from "./icons";

const Alert = ({
  type,
  position,
  hasBg,
  title,
  message,
  handleClose,
  className,
}) => {
  return (
    <div
      className={`rd--alert ${type} ${
        hasBg ? "bg-" + type : "no-bg"
      } ${className} ${position}`}
    >
      <div className="rd--alert__left">{icon_init_alert[type]}</div>
      <div className="rd--alert__mid">
        <p className={`title-07 ${type}`}>
          <b>{title}</b>
        </p>
        {message && (
          <p className={`paragraph paragraph-14 ${type}`}>{message}</p>
        )}
      </div>
      <div className={`rd--alert__right pointer ${type}`} onClick={handleClose}>
        {icon_close_alert[type]}
      </div>
    </div>
  );
};

Alert.propTypes = {
  type: PropTypes.oneOf(["success", "warning", "error"]),
  position: PropTypes.oneOf([
    "top-left",
    "top-mid",
    "top-right",
    "mid-left",
    "mid-mid",
    "mid-right",
    "bottom-left",
    "bottom-mid",
    "bottom-right",
  ]),
  hasBg: PropTypes.bool,
  title: PropTypes.string,
  message: PropTypes.string,
  handleClose: PropTypes.func,
  className: PropTypes.string,
};

Alert.defaultProps = {
  handleClose: () => {},
  title: "",
  message: "",
  className: "",
};

export default Alert;
